<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="4">
        <v-card class="py-3 px-4 vcard_area">
          <v-row>
            <v-col cols="12" md="7">
              <div class="text-h1 mb-2">Tarefas</div>
               <v-btn @click="dialogTarefa = true" color="primary" class="mt-1"><v-icon class="mr-1">add_task</v-icon>Nova tarefa</v-btn>
            </v-col>
            <v-col cols="12" md="5">
              <div class="icon_area_medium" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                <v-icon>add</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="8">
        <totalizador-tarefas :refresh="atualizaTotalizadores" v-on:reset-refresh="resetaRefresh"></totalizador-tarefas>
      </v-col>
    </v-row>
    <v-tabs
      next-icon="chevron_right"
      prev-icon="chevron_left"
      show-arrows
      class="ui-tabs"
      v-model="tabs">
      <v-tab>
        <v-icon>ballot</v-icon> Lista de tarefas
      </v-tab>
      <v-tab>
        <v-icon>calendar_month</v-icon> Calendário
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item class="px-1 pb-1">
        <lista-tarefas :abreDialog="dialogTarefa" :tarefaSelecionada="tarefaSelecionada" v-on:fecha-cadastro="fechaDialog"></lista-tarefas>
      </v-tab-item>
      <v-tab-item class="px-1 pb-1">
        <calendario-tarefas v-on:abre-tarefa="abreTarefa" :refresh="atualizaCalendario" v-on:reset-refresh="resetaRefresh"></calendario-tarefas>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import ListaTarefas from '../tarefas/ListaTarefas.vue'
import CalendarioTarefas from './CalendarioTarefas.vue'
import TotalizadorTarefas from '../tarefas/TotalizadorTarefas.vue'

export default {
  components: {
    ListaTarefas,
    CalendarioTarefas,
    TotalizadorTarefas
  },
  data () {
    return {
      tabs: 0,
      dialogTarefa: false,
      tarefaSelecionada: null,
      atualizaCalendario: false,
      atualizaTotalizadores: false
    }
  },
  methods: {
    abreTarefa (item) {
      this.tarefaSelecionada = item
      this.dialogTarefa = true
    },
    fechaDialog () {
      if (this.tarefaSelecionada) this.atualizaCalendario = true
      this.atualizaTotalizadores = true
      this.tarefaSelecionada = null
      this.dialogTarefa = false
    },
    resetaRefresh () {
      this.atualizaCalendario = false
      this.atualizaTotalizadores = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
</style>



// WEBPACK FOOTER //
// src/pages/tarefas/Tarefas.vue